import { authGuard } from '@auth0/auth0-vue';
import { createRouter, createWebHistory } from 'vue-router';
import { guestGuard } from './guards/guest-guard';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      beforeEnter: guestGuard,
    },
    {
      path: '/wallets',
      name: 'wallets',
      component: () => import('../views/WalletsView.vue'),
      beforeEnter: authGuard,
      children: [
        {
          path: ':id/transactions',
          name: 'transactions',
          component: () => import('../components/WalletTransactions.vue'),
        },
      ],
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import('../views/CallbackView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      beforeEnter: guestGuard,
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('../views/SignupView.vue'),
      beforeEnter: guestGuard,
    },
    {
      path: '/send',
      name: 'send',
      component: () => import('../views/SendView.vue'),
      beforeEnter: authGuard,
      children: [
        {
          path: 'from',
          name: 'send-from',
          component: () => import('../components/SendFrom.vue'),
        },
        {
          path: 'to',
          name: 'send-to',
          component: () => import('../components/SendTo.vue'),
        },
        // Send amount (Send here, effectively)
        {
          path: 'amount',
          name: 'send-amount',
          component: () => import('../components/SendAmount.vue'),
        },
        // Send confirmation (Not yet)
        // Send success
        {
          path: 'result',
          name: 'send-result',
          component: () => import('../components/SendResult.vue'),
        },
      ],
    },
    {
      path: '/institutions',
      name: 'institutions',
      component: () => import('../views/InstitutionsView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/institutions/create',
      name: 'institutions-create',
      component: () => import('../views/InstitutionsCreateView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/institutions/:id',
      name: 'institution',
      component: () => import('../views/InstitutionView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../views/AdminView.vue'),
      beforeEnter: authGuard,
      redirect: { name: 'admin-overview' },
      children: [
        {
          path: 'overview',
          name: 'admin-overview',
          component: () => import('../views/admin/OverviewView.vue'),
        },
        {
          path: 'institutions',
          name: 'admin-institutions',
          component: () => import('../views/admin/InstitutionsView.vue'),
        },
        {
          path: 'accounts',
          name: 'admin-accounts',
          component: () => import('../views/admin/AccountsView.vue'),
        },
        {
          path: 'management',
          name: 'admin-management',
          component: () => import('../views/admin/ManagementView.vue'),
        },
      ],
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/ProfileView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/SettingsView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('../views/LogoutView.vue'),
    },
    {
      path: '/logout/success',
      name: 'logout-success',
      component: () => import('../views/LogoutSuccessView.vue'),
    },
    {
      path: '/payments/cyberpay/result',
      name: 'cyberpay-result',
      component: () => import('../views/CyberPayResultView.vue'),
    },
  ],
});

export default router;
